import request from '@/utils/request'

/**
 * 获取项目列表
 * @param param
 */
export function fetchData(userId, query) {
  return request({
    url: `/api/project/all/${userId}`,
    method: 'post',
    data: query
  })
}
/**
 * 获取项目列表
 * @param param
 */
export function fetchCompanyAll(companyId, query) {
  return request({
    url: `/api/project/company/${companyId}`,
    method: 'post',
    data: query || {}
  })
}

/**
 * 是否有胜任力模型试题
 * @param param
 */
export function getModelType(projectId) {
  return request({
    url: `/api/project/fenc/${projectId}`,
    method: 'get',
  })
}

/**
 * 新增公告
 * @param param
 */
export function save(query) {
  return request({
    url: '/api/project/save',
    method: 'post',
    data: query
  })
}

/**
 * 修改公告
 * @param param
 */
export function update(query) {
  return request({
    url: '/api/project/update',
    method: 'post',
    data: query
  })
}

/**
 * 获取公告
 * @param param
 */
export function get(id) {
  return request({
    url: '/api/project/get/' + id,
    method: 'get'
  })
}

/**
 * 删除公告
 * @param param
 */
export function remove(id) {
  return request({
    url: '/api/project/delete/' + id,
    method: 'get'
  })
}


/**
 * 获取公司购买记录
 *
 * */

export const getBuyHistory = (userId, query) => {
  return request({
    url: '/api/recharge/' + userId + '/list',
    method: 'post',
    data: query
  })
}

/**
 * 查询我的项目数量
 *
 * */

export const getProjectNum = () => {
  return request({
    url: '/api/project/count',
    method: 'get',
  })
}

